export const paints = ({ paints }) => paints.byId;
